import React, {useState} from "react";
import {motion} from "motion/react";
import {r} from "@/utils/responsive";
import ShortcutText from "@/components/ShortcutText";
import ButtonMain from "./ButtonMain";
import TextType from "./TextType";
import {useNav} from "@/hooks/useNav";
import ButtonSpan from "@/components/ButtonSpan";
import ShortcutReforge from "@/components/ShortcutReforge";
import {useShortcuts} from "@/hooks/useShortcuts";

interface IntroTextProps extends React.HTMLAttributes<HTMLDivElement> {
}

const IntroText: React.FC<IntroTextProps> = ({className, ...props}) => {
    const [isTypingParagraph1, setIsTypingParagraph1] = useState<boolean>(true);
    const [isTypingParagraph2, setIsTypingParagraph2] = useState<boolean>(true);
    const {navigateToSection, isTransitioning, currentSection} = useNav();
    const shouldHide = isTransitioning && currentSection === "intro_text";

    useShortcuts({
        onEnter: () => navigateToSection("intro_universe"),
        enabledSections: ['intro_text']
    });

    return (
        <motion.div
            // animate={{opacity: shouldHide ? 0 : 1}}
            transition={{duration: 0.4, ease: "easeOut"}}
            style={{
                letterSpacing: r.vmax(-0.6),
                position: "absolute",
                top: r.vmax(190),
                left: "50%",
                transform: `translate(-50%, 0)`,
                width: r.vmax(952),
                height: r.vmax(760),
                display: "flex",
                flexDirection: "column",
                gap: r.vmax(0),
            }}
        >
            <motion.div
                style={{position: "relative", display: "flex", flexDirection: "column", gap: r.vmax(46)}}
                initial={{y: 20, opacity: 0}}
                animate={{y: 0, opacity: 1}}
                transition={{duration: 0.6, ease: "easeOut"}}
            >
                <div style={{
                    position: 'relative'
                }}>
                    <TextType
                        showCursor={isTypingParagraph1}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            whiteSpace: "pre-wrap",
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: r.vmax(64),
                            lineHeight: r.vmax(78),
                        }}
                        text={[
                            `Город Подарагон разрушен. \nСервисы не отвечают, поды \nпадают, хранилища недоступны.`,
                        ]}
                        onAnimationComplete={() => setIsTypingParagraph1(false)}
                    />
                    <p
                        style={{
                            whiteSpace: "pre-wrap",
                            color: "rgba(255, 255, 255, 1)",
                            fontSize: r.vmax(64),
                            lineHeight: r.vmax(74),
                            opacity: 0,
                            pointerEvents: "none",
                            userSelect: "none",
                        }}
                    >
                        {`Город Подарагон разрушен. \nСервисы не отвечают, поды \nпадают, хранилища недоступны.`}
                    </p>
                </div>
                {!isTypingParagraph1 && (

                    <div style={{
                        position: 'relative'
                    }}>
                        <TextType
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                whiteSpace: "pre-wrap",
                                color: "rgba(255, 255, 255, 1)",
                                fontSize: r.vmax(64),
                                lineHeight: r.vmax(78),
                            }}
                            text={[
                                `Только вы можете стать \nМастером K8s и спасти систему, \nпобедив Сhaos Monster!`,
                            ]}
                            onAnimationComplete={() => setIsTypingParagraph2(false)}
                        />
                        <p
                            style={{
                                whiteSpace: "pre-wrap",
                                color: "rgba(255, 255, 255, 1)",
                                fontSize: r.vmax(64),
                                lineHeight: r.vmax(74),
                                opacity: 0,
                                pointerEvents: "none",
                                userSelect: "none",
                            }}
                        >
                            {`Только вы можете стать Мастером\nK8s и спасти систему, победив\nСhaos Monster!`}
                        </p>
                    </div>
                )}
            </motion.div>
            <div style={{
                transform: `translate(${r.vmax(-4)}, ${r.vmax(-8)})`,
            }}>

                <motion.div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        maxWidth: r.vmax(950),
                        gap: r.vmax(24),
                    }}
                    initial={{y: 20, opacity: 0}}
                    animate={{y: isTypingParagraph2 ? 20 : 0, opacity: isTypingParagraph2 ? 0 : 1}}
                    transition={{duration: 0.6, ease: "easeOut"}}
                >
                    <ButtonMain onClick={() => navigateToSection("intro_universe")}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: `max(${r.vmax(12)}, 12px)`,
                            }}
                        >
                            <ButtonSpan>Восстановить порядок</ButtonSpan>
                            <ShortcutReforge isLarge>ENTER</ShortcutReforge>
                        </div>
                    </ButtonMain>
                    <motion.span
                        style={{
                            flex: 1,
                            textAlign: "center",
                            fontSize: r.vmax(24),
                            lineHeight: r.vmax(40),
                            color: "rgba(255, 255, 255, 0.7)",
                            letterSpacing: r.vmax(-0.2)
                        }}
                        initial={{y: 20, opacity: 0}}
                        animate={{y: isTypingParagraph2 ? 20 : 0, opacity: isTypingParagraph2 ? 0 : 1}}
                        transition={{
                            duration: 0.6,
                            ease: "easeOut",
                            delay: isTypingParagraph2 ? 0 : 0.3,
                        }}
                    >
                        {`Хотите управлять клавиатурой? Используйте хоткеи`}
                    </motion.span>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default IntroText;
